export default {
  metaTitle: 'USFans Spreadsheet: kompletny przewodnik po listach twórców i katalogach',
  metaDescription:
    'Dowiedz się, czym jest USFans Spreadsheet, jak korzystać z list twórców i katalogów, a także poznaj wskazówki dotyczące bezpieczeństwa, porównania i FAQ.',
  breadcrumbHome: 'Strona główna',
  updated: 'Ostatnia aktualizacja: sierpień 2026',
  badge: 'Oryginalny przewodnik',
  h1: 'USFans Spreadsheet: kompletny przewodnik po listach twórców i katalogach',
  introP1:
    'USFans Spreadsheet to uporządkowany sposób przeglądania i organizowania informacji o twórcach, zasobach i przewodnikach związanych z platformą USFans. Zamiast otwierać dziesiątki kart przeglądarki, dobrze zbudowany arkusz gromadzi profile twórców, kategorie, linki i przydatne notatki w jednym miejscu, które możesz filtrować, sortować i porównywać.',
  introP2:
    'Ten przewodnik wyjaśnia, czym jest USFans Spreadsheet, dlaczego jest używany, jak wypada w porównaniu z katalogami i bazami danych oraz o czym pamiętać w kwestii bezpieczeństwa i prywatności.',
  whatTitle: 'Czym jest USFans Spreadsheet?',
  whatP1:
    'USFans Spreadsheet to uporządkowana tabela gromadząca informacje o twórcach w jednym widoku. Wiersze zwykle zawierają nazwę twórcy, kategorię, krótki opis i link do oryginalnego źródła. Kolumny pozwalają sortować według niszy, popularności lub statusu, dzięki czemu szybciej znajdziesz to, czego potrzebujesz.',
  whatP2:
    'Ponieważ wszystko jest ułożone obok siebie, arkusz jest szczególnie przydatny dla początkujących, którzy chcą najpierw uzyskać ogólny obraz, zanim zagłębią się w konkretnych twórców lub zasoby.',
  whyTitle: 'Dlaczego warto używać arkusza do badania USFans?',
  whyLead: 'Dobry arkusz oferuje kilka praktycznych korzyści:',
  whyList: [
    'Wszystkie informacje w jednym miejscu',
    'Szybsze wyszukiwanie i filtrowanie',
    'Przyjazne dla początkujących przeglądy i przewodniki',
    'Porównania różnych opcji obok siebie',
    'Zaktualizowane informacje o bezpieczeństwie i prywatności',
    'Przejrzysta struktura, do której możesz wracać',
  ],
  compareTitle: 'Arkusz vs Katalog vs Baza danych',
  compareIntro: 'Te trzy formaty się pokrywają, ale każdy służy nieco innemu celowi:',
  compareColFeature: 'Cecha',
  compareColSpreadsheet: 'Arkusz',
  compareColDirectory: 'Katalog',
  compareColDatabase: 'Baza danych',
  compareOrg: 'Organizacja',
  compareFilter: 'Filtrowanie',
  compareBeginner: 'Przyjazny dla początkujących',
  compareMaint: 'Utrzymanie',
  compareBest: 'Najlepszy do',
  compareHigh: 'Wysokie',
  compareMedium: 'Średnie',
  compareQuick: 'Szybkie listy',
  compareBrowse: 'Przeglądanie',
  compareLarge: 'Duże dane',
  safetyTitle: 'Bezpieczeństwo i prywatność przy badaniu USFans',
  safetyP1:
    'Arkusz to tylko narzędzie do organizowania informacji — Twoje bezpieczeństwo zależy od źródeł i linków, które otwierasz. Stosuj te zasady:',
  safetyList: [
    'Zweryfikuj oficjalną domenę przed podaniem jakichkolwiek informacji',
    'Nigdy nie udostępniaj haseł, kodów weryfikacyjnych ani danych karty',
    'Uważaj na linki phishingowe imitujące popularne marki',
    'Przeczytaj politykę prywatności i warunki korzystania',
    'Weryfikuj informacje w więcej niż jednym źródle',
  ],
  faqTitle: 'Najczęściej zadawane pytania',
  faqQ1: 'Czy USFans Spreadsheet jest bezpieczny?',
  faqA1:
    'Arkusz sam w sobie to tylko sposób na uporządkowanie informacji. Bezpieczeństwo zależy od linków i źródeł, które otwierasz, więc zawsze weryfikuj je przed kliknięciem.',
  faqQ2: 'Jak korzystać z USFans Spreadsheet?',
  faqA2:
    'Otwórz go w preferowanym edytorze, używaj filtrów, aby zawęzić twórców według kategorii, i korzystaj z linków do źródeł, aby uzyskać aktualne informacje.',
  faqQ3: 'Gdzie znajdę informacje o twórcach?',
  faqA3:
    'Dobrym punktem wyjścia są katalogi, oficjalne zasoby i dyskusje społeczności. Zawsze weryfikuj szczegóły w więcej niż jednym źródle.',
  faqQ4: 'Czy USFans jest wiarygodny?',
  faqA4:
    'Sprawdź domenę, politykę prywatności i opinie użytkowników przed udostępnieniem danych osobowych, i unikaj nieoficjalnych stron proszących o poufne informacje.',
  relatedTitle: 'Powiązane przewodniki',
  ctaTitle: 'Szukasz więcej informacji o USFans?',
  ctaSubtitle: 'Odwiedź naszą główną stronę, aby poznać przewodniki, porównania i najnowsze zasoby.',
  ctaButton: 'Odwiedź główny sklep',
  backHome: 'Powrót do strony głównej',
};